var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import CoveragesCtrl from '../common/coveragesCtrl';

var GeneralCoveragesCtrl = function (_CoveragesCtrl) {
    _inherits(GeneralCoveragesCtrl, _CoveragesCtrl);

    function GeneralCoveragesCtrl() {
        _classCallCheck(this, GeneralCoveragesCtrl);

        return _possibleConstructorReturn(this, (GeneralCoveragesCtrl.__proto__ || Object.getPrototypeOf(GeneralCoveragesCtrl)).apply(this, arguments));
    }

    _createClass(GeneralCoveragesCtrl, [{
        key: 'setCoverages',
        value: function setCoverages(updateCoverage, updatedCoverages) {
            this.CoveragesUtil.updateCoverages(updateCoverage, updatedCoverages.lobCoverages, this.coverages.value.lobCoverages);
            this.coverages.value.schedules = updatedCoverages.schedules ? updatedCoverages.schedules : undefined;
        }
    }]);

    return GeneralCoveragesCtrl;
}(CoveragesCtrl);

export default GeneralCoveragesCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-bop-components-angular/coverages/general/generalCoveragesCtrl.js
// module id = 969
// module chunks = 0